import styled from 'styled-components';

const Container = styled.div`
    margin-top: 1.2rem;
    /* z-index: 1; */
    display: ${({ honeyPot }) => (honeyPot ? 'none' : 'inherit')};
    position: relative;
    border: 1px solid
        ${({ theme, focused }) =>
        focused ? theme.secondaryColor : theme.borderColor};
    border-radius: 7px;
    padding: 0.32rem 1.1rem;
    border: 1px solid #cfdade;
    background: white;

    @media (max-width: 660px) {
        padding: 0.32rem 0.5rem;
    }

    &:focus {
        outline: none;
    }

    input {
        background: transparent;
        outline: none;
        font-size: 16px;
        width: 100%;
        min-width: 192px;
        border: none;
        height: 46px;
        color: ${({ theme }) => theme.secondaryColor};
        background: white;

        @media (max-width: 1050px) {
            font-size: 14px;
            height: 42px;
        }

        &:focus {
            outline: none !important;
            border-color: inherit;
        }
    }

    textarea {
        resize: none;
        border: none;
        padding: 15px 0px;
        font-size: 14px;
        outline: none;
        width: 100%;
        font-family: ${({ theme }) => theme.primaryFont};
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 21px;
        letter-spacing: 0.2px;
    }

    /* Phone input component */
    .intl-tel-input {
        width: 100%;
        z-index: 9999;
        .flag-container {
            display: flex;
        }
        .selected-flag {
            margin-top: auto;
            margin-bottom: auto;
            height: fit-content;
            padding-top: 12px;
            padding-bottom: 15px;
            &:focus {
                border: 0.5px rgba(0, 0, 0, 0.25) solid;
                border-radius: 4px;
            }
        }
    }
    .intl-tel-input .flag-container .arrow {
        margin-left: 10px;
        margin-top: 3px;
    }
    .intl-tel-input .flag-container .arrow.down:after {
        content: url('/static/images/new_web/icons/arrow-down.svg');
    }
    .intl-tel-input .flag-container .arrow.up:after {
        content: url('/static/images/new_web/icons/arrow-up.svg');
    }
    .intl-tel-input .selected-flag:focus {
        border: none;
        border-radius: 4px;
    }

    .intl-tel-input .country-list {
        border: none;
        border-radius: 12px;
        padding: 0.5rem;
        overflow-y: scroll;
        z-index: 9999999;
        transform: translate(-10px, 46px);
        width: 105%;

        .country {
            white-space: normal;
            font-size: 14px;
        }
    }
    .selected-flag {
        width: 30px;
        &:focus {
            outline: none;
        }
    }
    .iti-flag {
        box-shadow: none;
        /* background-color: transparent; */
        &:focus {
            border: none;
            outline: none;
            box-shadow: none;
        }
    }
    .intl-tel-input.allow-dropdown .flag-container:hover .selected-flag {
        background-color: transparent;
    }
`;

const DatePickerInput = styled.div`
    .nice-dates-popover {
        margin: 1rem 0 8px 0px;
        z-index: 10001;
    }

    min-height: 42px;

    .nice-dates-grid {
        margin-top: 8px;
    }
`;

const Label = styled.label`
    position: absolute;
    left: ${({ focused, phoneInput }) => {
        if (focused) return '16px';
        if (phoneInput) return '72px';
        return '17.5px';
    }};
    top: ${({ focused }) => (focused ? '-11px' : '15px;')};

    padding: 0.1rem;
    transition: 0.2s ease all;
    user-select: none;
    font-size: ${({ focused }) => (focused ? '12px' : '14px;')};
    color: ${({ focused, labelColor }) => {
        if (focused) return labelColor || 'black';
        return '#8c8c8c';
    }};
    cursor: text;
    z-index: 2;

    @media (max-width: 1050px) {
        font-size: ${({ focused }) => (focused ? '12px' : '14px;')};
    }

    background: ${({ focused }) => (focused ? 'white' : 'white;')};
`;

const Calendar = styled.img`
    top: 19px;
    right: 20px;
    position: absolute;
`;

const DateInput = styled.input`
    z-index: 9999;
    position: relative;

    ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: transparent;
    }
    git p :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: transparent;
    }
    ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: transparent;
    }
    :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: transparent;
    }
    input::placeholder {
        color: transparent;
    }
`;

export { Container, Label, DatePickerInput, DateInput, Calendar };
